export function QuoteCard() {
  return (
    <div className="bento-no-min row-span-3 flex flex-col h-full">
      <h3 className="font-heading text-md [@media(min-width:414px)]:text-lg text-foreground mb-4">
        Engineering That Pays Back
      </h3>
      <p className="font-body text-sm text-muted-foreground font-light leading-relaxed">
        "From Sky Media to seven years of platform integrations, I have learned that data only matters when it changes a decision. Every system I build answers one question: what is truly driving the revenue?"
      </p>
    </div>
  );
}